import { commonConstants } from "./constants/commonConstants";

const getServicesList = () => (
    { type: commonConstants.getServicesListRequest }
)

const getSpecializationsList = () => (
    { type: commonConstants.getSpecializationsListRequest }
)

const getDocumentTypesList = () => (
    { type: commonConstants.getDocumentTypesListRequest }
)
 const setLoading =(payload:any)=>({
    type:commonConstants.setLoading,
    payload:payload
 })

const uploadFile = (payload: any) => ({
    type: commonConstants.uploadFileRequest,
    payload
})

const removeFile = (payload: any) => ({
    type: commonConstants.removeFileRequest,
    payload
})

const successResponse = (payload: any) => ({
    type: commonConstants.showSuccessMessage, payload: payload
});
const errorResponse = (payload: any) => ({
    type: commonConstants.showErrorMessage, payload: payload
});

const getListRole = (payload: any) => ({
    type: commonConstants.getRoleRequest,
    payload: payload
});

const getStudioList = (payload: any) => ({
    type: commonConstants.getStudioListRequest,
    payload: payload
});

const getUserNotificationList = (request: any) => {
    return { type: commonConstants.listNotificationsRequest, input: request };
};

const getNotificationCount = (count: any) => {
    return { type: commonConstants.getNotificationCountRequest, payload: count };
};

const fetchNotificationSettings = (userId: string) => ({
    type: commonConstants.fetchNotificationSettingsRequest,
    payload: userId,
});

const updateNotificationSettings = (services: Record<string, string[]>) => ({
    type: commonConstants.updateNotificationSettingsRequest,
    payload: { services },
});

const markAllRead = () => ({
    type: commonConstants.markAllReadRequest,
});

const markOneRead = (id: string) => ({
    type: commonConstants.markOneReadRequest,
    payload: { id },
});

const contactUs = (payload: any) => ({
    type: commonConstants.contactUsRequest,
    payload,
});
const getRoutes = () => ({ type : commonConstants.getRoutesListRequest });

const getAccessibleRoutes = () => ({ type: commonConstants.getAccessibleRoutesListRequest });
const viewNotification = (id: string) => ({
    type: commonConstants.viewNotificationRequest,
    payload: { id },
});

const kycNameCheck = (payload: any) => ({
    type: commonConstants.kycNameCheckRequest,
    payload
});
const generateSessionSas = ()=>({
    type:commonConstants.generateSessionSasRequest,
})

export const commonActions = {
    getServicesList,
    getSpecializationsList,
    getDocumentTypesList,
    uploadFile,
    removeFile,
    successResponse,
    errorResponse,
    getListRole,
    getStudioList,
    getNotificationCount,
    getUserNotificationList,
    fetchNotificationSettings,
    updateNotificationSettings,
    markAllRead,
    markOneRead,
    setLoading,
    contactUs,
    getRoutes,
    getAccessibleRoutes,
    viewNotification,
    kycNameCheck,
    generateSessionSas
}

